import React from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Auth from "../Auth";
import UserMenu from "./UserMenu";
import taskmanagerLogo from "../images/taskmanager_logo.png";

const Header = () => (
  <Row className="header-bar">
    <Col xs={11}>
      <Link to="/">
        <img
          src={taskmanagerLogo}
          alt="Task Manager Logo"
          style={{ width: 380, height: 68 }}
        />
      </Link>
    </Col>

    <Col xs={1}>
      <div className="header-actions">
        {Auth.isLoggedIn() ? <UserMenu /> : ""}
      </div>
    </Col>
  </Row>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js